  <!-- 滚动轮播 -->
  <template>
    <div>
      <el-carousel height="377px">
        <el-carousel-item v-for="(item,index) in slice" :key="index">
          <img :src="item">
        </el-carousel-item>
      </el-carousel>
    </div>
  </template>

<script>
import { Config } from "@/api/";
export default {
  name: 'slice',
  data(){
    return {
      slice:[],
    }
  },
  props:{

  },
  mounted(){
    this.getDefaultSlice();
  },
  methods:{
    getDefaultSlice(){
      var that = this;
      Config({configType:'slice'}).then(res=>{
        that.slice = res.data;
      })
    }
  }
}
</script>
<style scoped>
  @media screen and (max-width:480px) {
    .el-carousel--horizontal{display: none;}
  }
.el-carousel__item img{
  width: 100%;
}
</style>>